module.exports = __webpack_public_path__ + "4b363f72b068f41843c15b53ef894c6a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/profiles/profile/extended/extended.html
// module id = 2115
// module chunks = 0